/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SportsClubSubscriptionDetailsDto } from '../models/SportsClubSubscriptionDetailsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubscriptionControllerService {
    /**
     * @param sportsClubId
     * @returns SportsClubSubscriptionDetailsDto OK
     * @throws ApiError
     */
    public static getSubscriptionsBySportsClubId(
        sportsClubId: number,
    ): CancelablePromise<SportsClubSubscriptionDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/subscriptions/sports-club/{sportsClubId}',
            path: {
                'sportsClubId': sportsClubId,
            },
        });
    }
}
